import { AES, enc } from 'crypto-js';
import getFingerprint from './fingerprint';
import { IsNullOrUndefined } from './valid';

// 加解密金鑰：改用 localStorage 的固定裝置金鑰（deviceKey），第一次隨機產生後固定使用，
// 不再依賴會飄動的瀏覽器指紋（指紋會因電視韌體更新 / canvas 飄動而改變，導致舊資料解不開）。
const getSecureKey = () => {
  try {
    let key = window.localStorage.getItem('deviceKey');
    if (!key) {
      key =
        window.crypto && window.crypto.randomUUID
          ? window.crypto.randomUUID()
          : String(Date.now()) + Math.random();
      window.localStorage.setItem('deviceKey', key);
    }
    return key;
  } catch (e) {
    // localStorage 不可用（隱私模式等極端情況）時退回指紋，至少能運作
    return getFingerprint().toString();
  }
};

const secureKey = getSecureKey();

export const GetEncryptedString = (val) => {
  if (IsNullOrUndefined(val)) return null;

  return AES.encrypt(val, secureKey).toString();
};

export const GetDecryptedString = (val) => {
  if (IsNullOrUndefined(val)) return null;

  try {
    return AES.decrypt(val, secureKey).toString(enc.Utf8);
  } catch (ex) {
    return null;
  }
};

export const GetEncryptObject = (obj) => {
  if (IsNullOrUndefined(obj)) return null;

  return AES.encrypt(JSON.stringify(obj), secureKey).toString();
};

export const GetDecryptedObject = (val) => {
  if (IsNullOrUndefined(val)) return null;

  try {
    const decryptedObject = AES.decrypt(val, secureKey).toString(enc.Utf8);
    return decryptedObject ? JSON.parse(decryptedObject) : null;
  } catch (ex) {
    return null;
  }
};
